// Unpublished Work © 2023-2024 Deere & Company.

export const AVAILABILITY = 'availability';
export const WEATHER = 'weather';
export const WORKBOARD = 'workboard';
